import useSnackbar from './hooks/useSnackbar'
import Snackbar from '../control/Snackbar'
import Button from '../control/Button'

type SnackbarPlaygroundType = ReturnType<typeof useSnackbar>

const SnackbarPlaygroundView = (props: SnackbarPlaygroundType) => {
    const { open, type, onOpen, onClose } = props

    return (
        <>
            <div>
                <Button
                    onClick={() => {
                        onOpen('info')
                    }}
                >
                    Open snackbar (info)
                </Button>
            </div>
            <div>
                <Button
                    onClick={() => {
                        onOpen('success')
                    }}
                >
                    Open snackbar (success)
                </Button>
            </div>
            <div>
                <Button
                    onClick={() => {
                        onOpen('warning')
                    }}
                >
                    Open snackbar (warning)
                </Button>
            </div>
            <div>
                <Button
                    onClick={() => {
                        onOpen('error')
                    }}
                >
                    Open snackbar (error)
                </Button>
            </div>

            <Snackbar isOpen={open} onClose={onClose} message={'This is an information message!'} type={type} />
        </>
    )
}

//Controller
const SnackbarPlayground = () => {
    const snackbarModel = useSnackbar()
    return <SnackbarPlaygroundView {...snackbarModel} />
}

export default SnackbarPlayground
